import { EntityType } from "api/admin/src";
export var TagEntityType;
(function (TagEntityType) {
    TagEntityType[TagEntityType["ENTITYTYPE_UNSPECIFIED"] = 0] = "ENTITYTYPE_UNSPECIFIED";
    TagEntityType[TagEntityType["PORTFOLIO"] = 1] = "PORTFOLIO";
    TagEntityType[TagEntityType["FUND"] = 2] = "FUND";
    TagEntityType[TagEntityType["MANAGER"] = 3] = "MANAGER";
    TagEntityType[TagEntityType["ASSET"] = 4] = "ASSET";
    TagEntityType[TagEntityType["INVESTOR"] = 5] = "INVESTOR";
    TagEntityType[TagEntityType["FUND_SERIES"] = 6] = "FUND_SERIES";
})(TagEntityType || (TagEntityType = {}));
export const TagEntityTypeToEntityTypeMap = {
    [EntityType.Portfolio]: TagEntityType.PORTFOLIO,
    [EntityType.Fund]: TagEntityType.FUND,
    [EntityType.FundSeries]: TagEntityType.ENTITYTYPE_UNSPECIFIED,
    [EntityType.Manager]: TagEntityType.MANAGER,
    [EntityType.Asset]: TagEntityType.ASSET,
    [EntityType.Market]: TagEntityType.ENTITYTYPE_UNSPECIFIED
};
